/**
 * ============================================================================
 * M1 STUB — REMOVED AT THE LIVE-DATA SWITCHOVER.
 * ============================================================================
 * The Cash Dash subgraph does not exist yet, so this hook stands in for the
 * eventual codegen'd distinct-filter-values query (entity names + bank
 * accounts). It supplies `agSetColumnFilter`'s `filterParams.values`
 * explicitly — under `rowModelType: "serverSide"`, AG Grid can otherwise only
 * infer set-filter values from the currently-loaded page, which
 * under-populates the picker.
 * ============================================================================
 */
import { useMemo } from "react";
import { defaultCashTransactions } from "./mocks";

/** A bank account filter option: the `bankAccountId` value + its display label. */
export type BankAccountFilterOption = {
  value: string;
  label: string;
};

export type CashTransactionFilterValues = {
  entityNames: string[];
  bankAccounts: BankAccountFilterOption[];
};

const ENTITY_NAMES: string[] = Array.from(
  new Set(defaultCashTransactions.map((t) => t.entityName)),
).sort();

const BANK_ACCOUNTS: BankAccountFilterOption[] = Array.from(
  new Map(
    defaultCashTransactions.map((t) => [
      t.bankAccountId,
      { value: t.bankAccountId, label: `${t.bankName} ...${t.bankAccountLast4}` },
    ]),
  ).values(),
).sort((a, b) => a.label.localeCompare(b.label));

/** Stub of the eventual `useGetCashTransactionFilterValuesQuery`. */
export const useCashTransactionFilterValuesStub = (): CashTransactionFilterValues =>
  useMemo(() => ({ entityNames: ENTITY_NAMES, bankAccounts: BANK_ACCOUNTS }), []);
